import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
// eslint-disable-next-line max-len
import { CopyCropFieldsToManureSpaceProgressComponent } from './components/copy-cropfields-to-manure-space-progress/copy-cropfields-to-manure-space-progress.component';
// eslint-disable-next-line max-len
import { CopyCropFieldsToManureSpaceProgressDialogComponent } from './components/copy-cropfields-to-manure-space-progress-dialog/copy-cropfields-to-manure-space-progress-dialog.component';
// eslint-disable-next-line max-len
import { CopyCropFieldsToManureSpaceStatusComponent } from './components/copy-cropfields-to-manure-space-status/copy-cropfields-to-manure-space-status.component';
import { CopyCropFieldsToManureSpaceEffects } from './store/copy-cropfields-to-manure-space.effects';
import { reducer } from './store/copy-cropfields-to-manure-space.reducer';

@NgModule({
  declarations: [
    CopyCropFieldsToManureSpaceProgressDialogComponent,
    CopyCropFieldsToManureSpaceProgressComponent,
    CopyCropFieldsToManureSpaceStatusComponent,
  ],
  imports: [SharedModule, AgrDialogModule, MatProgressBarModule, MatIconModule, MatButtonModule],
  providers: [
    provideState('copyCropFieldsToManureSpace', reducer),
    provideEffects([CopyCropFieldsToManureSpaceEffects]),
  ],
  exports: [CopyCropFieldsToManureSpaceStatusComponent],
})
export class CopyCropFieldsToManureSpaceModule {}
